/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { REDUCER_KEY_RS } from '@Pages/RetroSynthesis/RetroSynthesisProjects/constants';
import { REDUCER_KEY_PROJECT_CREATION_DIALOG } from '@Pages/RetroSynthesis/ProjectParametersDialog/constants';
import { fetchAutoplanOptionsAction } from '@Pages/RetroSynthesis/ProjectParametersDialog/action';
import DrawStructure from '@Pages/RetroSynthesis/DrawStructure/DrawStructure';
import { addProjectAction, clearProjectToEditState } from '@Pages/RetroSynthesis/RetroSynthesisProjects/actions';
import { RsRoute } from '@Pages/RetroSynthesis/routes';
import { withRouter } from 'react-router-dom';
import { getCreatedProject, getProjectToEdit } from '@Pages/RetroSynthesis/RetroSynthesisProjects/selectors';
import isNil from 'lodash/isNil';
import { useUserSettings } from '@Hooks/userHooks';
import { StructureEditorType } from '@Containers/StructureEditor/constants';
import { editorType as editorTypeSelector, isLoading as isLoadingSelector } from '@Pages/RetroSynthesis/DrawStructure/selectors';
import { setEditorType as setEditorTypeAction, setLoading as setLoadingAction } from '@Pages/RetroSynthesis/DrawStructure/actions';
import SimpleSpinner from '@Components/Results/utils/SimpleSpinner';
import { RESPONSE, VENDORS_INFO } from '@Pages/RetroSynthesis/ProjectParametersDialog/reducer';
import { getHasProjects } from '@Pages/RetroSynthesis/RsBreadcrumbs/selector';
import { onPageLoad } from './analytics';
import { updateParamsForBE, updatePredictedParamsFromBE } from '../predictiveUtils';

/* eslint-disable react/prop-types */
/* eslint-disable no-shadow */
/* eslint-disable react-hooks/exhaustive-deps */
function DrawStructureContainer({
  fetchAutoplanOptions,
  addProject,
  hasProjects,
  response,
  vendorsInfo,
  history,
  projectToEdit,
  clearProject,
  editorType,
  setEditorType,
  createdProject,
  isLoading,
  setLoading,
}) {
  const initialPublishedParameters = projectToEdit && projectToEdit.publishedParameters;
  const initialPredictedParameters = projectToEdit && updatePredictedParamsFromBE(projectToEdit.predictedParameters);
  const initialStructure = projectToEdit && projectToEdit.targetStructure && projectToEdit.targetStructure.structure;
  const isEditedProject = !!projectToEdit;

  useEffect(() => {
    setLoading(true);
    onPageLoad(projectToEdit);
    fetchAutoplanOptions();
    const skipLinkFooter = document.getElementById('els-skiplink-footer');
    const footerListItem = skipLinkFooter ? skipLinkFooter.parentElement : null;
    if (footerListItem) {
      footerListItem.style.display = 'none'; // Hide the element that contains the skip link for footer
    }
    return () => {
      clearProject();
      if (footerListItem) {
        footerListItem.style.display = ''; // Reset display to show the footer element again
      }
    };
  }, []);

  // Go to projects only if project was created
  useEffect(() => {
    if (createdProject && createdProject.id) {
      history.replace(RsRoute.PROJECTS_LIST);
    }
  }, [createdProject, history]);

  useEffect(() => {
    if (response && isLoading) {
      // hide loading params spinner
      setLoading(false);
    }
  }, [response]);

  // Initialize default editor from user settings just once...
  useUserSettings((userSettings) => {
    const { structureEditorPreselected } = userSettings;

    if (isNil(editorType)) {
      setEditorType(StructureEditorType.getFromSetting(structureEditorPreselected) || StructureEditorType.MARVIN);
    }
  });

  const submitStructureHandler = async (params, structure) => {
    const updatedProjectParams = updateParamsForBE({ ...params, structure });
    await addProject(updatedProjectParams, {
      editorType,
      isEditedProject,
      location: history.location,
    });
  };

  return (
    <>
      {isLoading && <SimpleSpinner />}
      <DrawStructure
        optionResponse={response}
        vendorsInfo={vendorsInfo}
        doSubmit={submitStructureHandler}
        hasProjects={hasProjects}
        structure={initialStructure}
        initialPublishedParameters={initialPublishedParameters}
        initialPredictedParameters={initialPredictedParameters}
        editorType={editorType}
        setEditorType={setEditorType}
        isLoading={isLoading}
        setIsLoading={setLoading}
      />
    </>
  );
}

const mapStateToProps = (state) => {
  const rs = state.get(REDUCER_KEY_RS);
  const projectCreateDialog = rs.get(REDUCER_KEY_PROJECT_CREATION_DIALOG);
  return {
    response: projectCreateDialog && projectCreateDialog.get(RESPONSE),
    vendorsInfo: projectCreateDialog && projectCreateDialog.get(VENDORS_INFO),
    isLoading: isLoadingSelector(state),
    hasProjects: getHasProjects(state),
    projectToEdit: getProjectToEdit(state),
    editorType: editorTypeSelector(state),
    createdProject: getCreatedProject(state),
  };
};

const mapDispatchToProps = {
  fetchAutoplanOptions: fetchAutoplanOptionsAction,
  addProject: addProjectAction,
  clearProject: clearProjectToEditState,
  setEditorType: setEditorTypeAction,
  setLoading: setLoadingAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(DrawStructureContainer));
